export const TRUST_BADGES_STYLES = {
  root: "w-full",
  title:
    "text-center text-[11px] font-semibold uppercase tracking-wider text-ticketon-gray-600",
  list: "mt-3 flex flex-wrap items-center justify-center gap-x-10 gap-y-5 opacity-80",
  item: "flex items-center justify-center",
  logo: "h-8 w-auto object-contain grayscale transition hover:grayscale-0 md:h-10",
} as const;
